import * as yup from 'yup'

export const validateCreateListCustomerGroups = yup.object().shape({
    name:yup
    .string()
    .required('Campo requerido.')
    .min(2, 'El NOMBRE debe tener más de 2 caracteres'),
})